import Form from 'components/Form';
import { IFormValues, IFormRegister } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormRegister {
  disabled?: boolean;
}

const Summation = (props: Props) => {
  const { disabled, getValues, setValue, register } = props;

  return (
    <>
      <SectionTitle title="3. 환자의 임상 상태변화 요약" />
      <RowContainer xs={12}>
        <RowContent title="상태변화 요약" titleRatio={1.3} childrenRatio={10.7}>
          <Form.MuiTextField
            required={false}
            fullWidth
            disabled={disabled}
            placeholder="추가적인 내용을 적어주세요. "
            {...register('summation')}
          />
        </RowContent>
      </RowContainer>
    </>
  );
};

export default Summation;
